<template>
  <dashboard-section :bordered="$device.isMobileOrTablet">
    <div slot="header" class="d-flex ai-center">
      <img src="./assets/ToolRental.jpeg" alt="" class="IMG m-r-1"/>
    </div>
    <transition name="FADE" mode="out-in">
      <div>
        <div class="p-b-2">
          {{ message }}
        </div>
        <div>
          <button
              class="btn"
              @click.prevent="onRentNow">
            <span class="d-flex ai-center"> Rent Now </span>
          </button>
        </div>
      </div>
    </transition>
  </dashboard-section>
</template>

<script>
import jobParams from '@/mixins/job-params';
import job from '@/mixins/job';
import DashboardSection from '@/views/Dashboard/components/DashboardSection';


export default {
  name: 'tool-rental',
  components: {
    DashboardSection,

  },
  mixins: [
    jobParams,
    job,
  ],
  computed: {
    message () {
      switch (this.job.service_name) {
        case 'Ceiling Fan Installation': {
          return 'Rent everything you need to get the job done, from scaffolding and scissor lifts to reciprocating saws and more.';
        }
        case 'Interior Painting': {
          return 'Rent everything you need to get the job done, from paint sprayers and scaffolding to scissor lifts and more.';
        }
        case 'Deck Build': {
          return 'Rent everything you need to get the job done, from skid steers and augers to saws and power tools.';
        }
        default: {
          return 'Rent the tools, trucks, and large equipment that work as hard as you do.';
        }
      }
    },
  },
  methods: {
    onRentNow () {
      window.open('https://homedepot.com/rental', '_blank');
      this.$events.$emit(this.$events.TOOL_RENTAL_CLICK, { service: this.job.service_name });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

   .IMG {
    width: auto;
    height: 40px;
  }
  .WRAP-TEXT{
    word-break: break-word;
    white-space: normal;
}
</style>
